export const outpostDetailsLabelStyles = {
  styles: {
    label: {
      fontSize: '15px',
    },
  },
};
